import { render } from "./CadastroPlanosGarantePayView.vue?vue&type=template&id=c5af55d8"
import script from "./CadastroPlanosGarantePayView.vue?vue&type=script&lang=js"
export * from "./CadastroPlanosGarantePayView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__